<template>
  <div class="footer_container">
    <div class="footer_content">
      <div class="about_content">
        <h5 class="about_title">About</h5>
        <p class="about_description">
          ShonCompany.com is the official portfolio and direct booking platform of Shonpierre Williams, a real estate
          developer and systems strategist specializing in short‑term rentals, modular construction, and asset
          optimization. With active properties across Illinois, Texas, Missouri, and Arizona, Shon Company delivers
          premium, professionally managed stays—engineered for guest comfort, operational efficiency, and long‑term ROI.
        </p>
        <h4 class="about_link"><span>Email: </span> 551lakeh@gmail.com</h4>
        <h4 class="about_link"><span>Phone: </span> (512) 659-0910</h4>
      </div>
      <div class="quick_links">
        <h5 class="quick_title">Quick Link</h5>
        <ul>
          <router-link tag="li" to="/">
            Home
          </router-link>
          <router-link tag="li" to="about_us">
            About
          </router-link>
          <router-link tag="li" to="blogs">
            Blog
          </router-link>
          <router-link tag="li" to="contact_us">
            Contact
          </router-link>
          <!--          <router-link tag="li" to="/">-->
          <!--            Houses-->
          <!--          </router-link>-->
        </ul>
      </div>
      <div class="newsletter_container">
        <h4 class="newsletter_title">Newsletter</h4>
        <p class="newsletter_sub">Get blog articles and offers via email</p>
        <input
            class="newsletter_input"
            type="email"
            placeholder="Your Email"
            v-model="userForm.subscribe_email"
            :class="{ 'is-invalid': isSubmitted && $v.userForm.subscribe_email.$error }"
            trim
        >
        <div v-if="isSubmitted && $v.userForm.subscribe_email.$error" class="invalid-feedback">
          <span v-if="!$v.userForm.subscribe_email.required">Email field is required</span>
          <span v-if="!$v.userForm.subscribe_email.email">Please provide valid email</span>
        </div>
        <button
            class="newsletter_btn"
            @click="subscribeEmail()"
            :disabled="!userForm.subscribe_email"
        >Subscribe
        </button>
        <span v-if="success_msg" class="success_msg">{{ success_msg }}</span>
        <div v-if="errors" class="mt-1">
          <span v-for="error in errors" class="text-danger">{{error[0]}}</span>
        </div>
      </div>
    </div>
    <div class="footer_links">
      <ul>
        <router-link tag="li" to="/terms_of_use">
          Terms of Use
        </router-link>
        <router-link tag="li" to="/privacy_policy">
          Privacy Policy
        </router-link>
        <router-link tag="li" to="/cookie_policy">
          Cookie Policy
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import {email, minLength, required} from "vuelidate/lib/validators";

export default {
  name: "Footer",
  data() {
    return {
      userForm: {
        subscribe_email: "",
      },
      errors: [],
      debounceTimer: null,
      isSubmitted: false,
      success_msg: ""
    }
  },
  validations: {
    userForm: {
      subscribe_email: {
        required,
        email
      },
    }
  },
  methods: {
    ...mapActions(['emailSubscribe']),
    subscribeEmail() {
      this.errors = []
      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        this.isSubmitted = true;
        this.$v.$touch();
        if (this.$v.userForm.subscribe_email.$invalid) return;
        this.emailSubscribe(this.userForm)
            .then((res) => {
              if (res?.status === 200 || res?.status === 201) {
                this.isSubmitted = false
                this.userForm.subscribe_email = "";
                this.success_msg = "Thank you for subscribing!";
                setTimeout(() => {
                  this.success_msg = "";
                }, 8000);
              } else {
                this.errors = res.response.data.errors
              }
            })
            .catch((err) => {
              console.error("Subscription failed:", err);
            });
      }, 600);
    }
  }
}
</script>

<style scoped lang="scss">
.success_msg {
  font-size: 17px;
  font-weight: 600;
  color: green;
  margin-top: 10px;
}

.footer {
  &_container {
    width: 100%;
    border-top: 1px solid #242535;
    background: #13106B;
    padding-top: 65px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #FFFFFF;
    font-family: "Plus Jakarta Sans", sans-serif;
    @media screen and (max-width: 1680px) {
      padding-top: 45px;
    }
    @media screen and (max-width: 768px) {
      padding-top: 20px;
    }
  }

  &_content {
    max-width: 70%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media screen and (max-width: 1680px) {
      max-width: 70%;
    }
    @media screen and (max-width: 1024px) {
      max-width: 90%;
    }
    @media screen and (max-width: 768px) {
      max-width: 95%;
    }
    @media screen and (max-width: 540px) {
      flex-wrap: wrap;
      max-width: 90%;
    }

    & .about {
      &_content {
        @media screen and (max-width: 540px) {
          margin-bottom: 15px;
        }
        @media screen and (max-width: 440px) {
          max-width: 240px;
        }
      }

      &_title {
        color: #FFF;
        font-size: 18px;
        font-weight: 600;
        line-height: 28px;
        padding-bottom: 20px;
        @media screen and (max-width: 1440px) {
          font-size: 16px;
          padding-bottom: 10px;
          line-height: 24px;
        }
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
        @media screen and (max-width: 440px) {
          padding-bottom: 5px;

        }
      }

      &_description {
        color: #97989F;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        max-width: 400px;
        padding-bottom: 24px;
        @media screen and (max-width: 1440px) {
          line-height: 20px;
        }
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
        @media screen and (max-width: 540px) {
          padding-bottom: 5px;
        }
      }

      &_link {
        color: #97989F;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;

        & span {
          color: #fff;
          @media screen and (max-width: 768px) {
            font-size: 14px;
          }
        }
      }
    }

    & .quick {
      &_title {
        color: #FFF;
        font-size: 18px;
        font-weight: 600;
        line-height: 28px;
        padding-bottom: 20px;
        @media screen and (max-width: 1440px) {
          font-size: 16px;
          padding-bottom: 10px;
          line-height: 24px;
        }
        @media screen and (max-width: 768px) {
          font-size: 14px;
          margin-top: 0;
        }
      }

      &_links {
        @media screen and (max-width: 440px) {
          width: 90px;
          margin-bottom: 30px;
        }

        & ul {
          margin-bottom: 0;

          & li {
            list-style-type: none;
            color: #BABABF;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
            padding: 4px 0;

            &:hover {
              cursor: pointer;
              color: #068BD6;
            }

            @media screen and (max-width: 768px) {
              line-height: 20px;
            }
            @media screen and (max-width: 540px) {
              padding: 5px 0;
            }
          }
        }
      }
    }

    & .newsletter {
      &_container {
        border-radius: 12px;
        background: #030135;
        padding: 32px;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 390px;
        width: 100%;
        @media screen and (max-width: 768px) {
          max-width: 280px;
          padding: 15px;
        }
      }

      &_title {
        color: #FFF;
        text-align: center;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 120% */
        padding-bottom: 8px;
        @media screen and (max-width: 768px) {
          font-size: 16px;
          line-height: 18px;
        }
      }

      &_sub {
        color: #97989F;
        text-align: center;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 150% */
        padding-bottom: 30px;
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }

      &_input {
        width: 100%;
        border-radius: 6px;
        border: 1px solid var(--Secondary-600, #3B3C4A);
        background: var(--Secondary-800, #181A2A);
        padding: 12px 16px;
        color: white;
        @media screen and (max-width: 768px) {
          padding: 8px 14px;
        }
      }

      &_btn {
        margin-top: 8px;
        color: #FFF;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
        border-radius: 6px;
        background: #068BD6;
        width: 100%;
        padding: 12px 20px;
        border: none;
        @media screen and (max-width: 768px) {
          margin-top: 15px;
          padding: 6px 20px;
        }
      }
    }
  }

  &_links {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding-top: 40px;
    @media screen and (max-width: 1440px) {
      padding-top: 30px;
    }
    @media screen and (max-width: 768px) {
      padding-top: 20px;
    }

    & ul {
      display: flex;
      align-items: center;

      & li {
        padding: 5px 20px;
        color: #BABABF;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        list-style-type: none;
        @media screen and (max-width: 440px) {
          padding: 10px;
          font-size: 15px;
        }

        &:hover {
          color: #068BD6;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
